<div class="bv-get-started tw-rounded-xl tw-border tw-border-solid tw-p-5">
  <div class="tw-grid tw-grid-cols-[19px_minmax(0,1fr)] tw-items-center tw-gap-x-3">
    <img
      src="images/icons/brackets-vault/speedometer.svg"
      alt=""
      class="tw-h-[18px] tw-w-[19px] tw-object-contain"
      aria-hidden="true"
    />
    <button
      type="button"
      class="tw-flex tw-min-w-0 tw-w-full tw-items-center tw-gap-3 tw-border-0 tw-bg-transparent tw-p-0 tw-text-start tw-outline-none focus-visible:tw-rounded-md focus-visible:tw-ring-2 focus-visible:tw-ring-border-focus"
      (click)="open.set(!open())"
      [attr.aria-expanded]="open()"
    >
      <span class="bv-get-started__heading tw-shrink-0 tw-text-base tw-font-semibold">{{
        title()
      }}</span>
      <div
        class="bv-get-started__progress-track tw-h-1.5 tw-min-w-[4rem] tw-flex-1 tw-overflow-hidden tw-rounded-full"
        aria-hidden="true"
      >
        <div
          class="bv-get-started__progress-fill tw-h-full tw-rounded-full tw-transition-[width] tw-duration-300"
          [style.width.%]="progressPercent()"
        ></div>
      </div>
      <span class="bv-get-started__progress-label tw-shrink-0 tw-whitespace-nowrap tw-text-sm">
        @if (tasks().length > 0) {
          {{ "onboardingTasksComplete" | i18n: amountCompleted() : tasks().length }}
        }
      </span>
      <i
        class="bv-get-started__toggle-icon bwi tw-shrink-0 tw-text-xl"
        [class.bwi-angle-up]="open()"
        [class.bwi-angle-down]="!open()"
        aria-hidden="true"
      ></i>
    </button>
  </div>

  @if (open()) {
    <div class="tw-mt-5 tw-flex tw-flex-col tw-gap-5 tw-pl-[calc(19px+0.75rem)]" role="list">
      <ng-content></ng-content>
    </div>

    <div class="tw-pt-4 tw-text-right">
      <button
        bitLink
        type="button"
        linkType="primary"
        class="bv-get-started__dismiss"
        (click)="dismiss.emit()"
      >
        {{ "dismissThisChecklist" | i18n }}
      </button>
    </div>
  }
</div>
